import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';

export const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  background: `${theme.palette.grey[200]}`,
  flexGrow: '1',
}));
